<template>
    <div ref="shopControllerViewDom" class="full-width" v-loading="loading">

        <HomeHeader
            :returnLabel="i18n.tkey('lang_return')"
            :useChatBtn="true"
            @clickBackBtn="clickReturnBtn"
            v-if="showReturnBtn !== false"
        />

        <div class="padding-box">
            <div class="title-option-box" v-show="false && (viewPart === 'home' || viewPart === 'country')">
                <div>
                    <countryGroupEditor
                        @changeView="changeCountryPart"
                        v-if="null != shopCompanyObj"
                    />
                </div>
            </div>

            <div v-if="viewPart === 'home' && null != shopCompanyObj" style="margin-bottom: 20px">
                <div style="text-align: right">
                    <a :href="websiteUrl" target="eshopopee" v-if="null != shopCompanyObj.acccompanycode">
                        <el-button round style="margin-right: 10px" >
                            <font-awesome-icon icon="fa-solid fa-globe" />
                            &nbsp;
                            <span tkey="我的網站">{{i18n.tkey("lang_my_website")}}</span>
                        </el-button>
                    </a>
                </div>
                <shopHeader :useTitle="useTitle" style="border-top: none" />
            </div>

            <div v-show="viewPart === 'home'">
                <ShopHome v-if="null != shopCompanyObj" @clickBtn="goView" />
            </div>

            <div v-if="viewPart !== 'home'">

                <hallManager
                    @clickReturnBtn="goView('home')"
                    :showReturnBtn="false || (fullScreen === false)"
                    v-if="viewPart === 'hall'"
                />

                <DeliverynameEditor
                    v-if="viewPart === 'remark'"
                    @clickReturnBtn="goView('home')"
                    :showReturnBtn="false || (fullScreen === false)"
                />

<!--                <MaterialEditor
                    v-if="viewPart === 'material'"
                    @clickReturnBtn="goView('home')"
                />-->

                <TransportEditor
                    v-if="viewPart === 'delivery'"
                    @clickReturnBtn="goView('home')"
                />

                <PaymentEditor
                    v-if="viewPart === 'payment'"
                    @clickReturnBtn="goView('home')"
                />

                <InvitationRecord
                    v-if="viewPart === 'inv'"
                    @clickReturnBtn="goView('home')"
                />

                <AdsManager
                    v-if="viewPart === 'ads'"
                    @clickReturnBtn="goView('home')"
                />

                <ShopShare
                    v-if="viewPart === 'share'"
                    @clickReturnBtn="goView('home')"
                />

                <MyAgent
                    v-if="viewPart == 'agent'"
                    @clickReturnBtn="goView('home')"
                />
            </div>
        </div>

    </div>
</template>

<script setup>
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
    import {getCurrentInstance, onMounted, ref, computed, toRef, inject, provide} from "vue";
    import myUtil from "@/util/util"
    import shopHeader from "@/components/shopopee/shop/shopHeader"
    import countryGroupEditor from "@/components/shopopee/country/countryGroupEditor"
    import ShopHome from "@/components/shopopee/home/shopHome.vue";
    import HallManager from "@/components/shopopee/hall/hallManager.vue";
    import DeliverynameEditor from "@/components/shopopee/deliveryname/deliverynameEditor.vue";
    import MaterialEditor from "@/components/shopopee/material/materialEditor.vue";
    import TransportEditor from "@/components/shopopee/material/transportEditor.vue"
    import PaymentEditor from "@/components/shopopee/material/paymentEditor.vue";
    import InvitationRecord from "@/components/shopopee/invitaion/InvitationRecord.vue";
    import companyApi from "@/request/companyApi";
    import {useUserinfo} from "@/stores/userinfo";
    import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";
    import AdsManager from "@/components/shopopee/ads/adsManager.vue";
    import ShopShare from "@/components/shopopee/shop/shopShare.vue";
    //import AgentEditor from "@/components/shopopee/agent/agentEditor.vue";
    import MyAgent from "@/components/shopopee/agent/myAgent.vue";

    library.add(faArrowLeft)

    const i18n = inject("i18n")
    const { proxy } = getCurrentInstance();

    const props = defineProps(['useChat', 'useTitle', "showReturnBtn", "fullScreen"])

    const loading = ref(false)

    const userinfoRef = toRef(useUserinfo())
    //組件寬度
    const width = ref(425)
    //是否顯示國家編輯
    const viewPart = ref("home")

    //店铺控制室使用的company
    const shopCompanyObj = ref(null)
    const mparams = { name: 'myCompany', params: { mfrom: "shopController" } };
    const { goCompanyView } = inject('phoneView', { goCompanyView: () => {

      proxy.$router.push(mparams)
        }
    })

    const websiteUrl = computed(() => {
        return myUtil.generateEShopopeeShopUrl(shopCompanyObj.value.acccompanycode)
    })

    function changeCountryPart(){
        if (viewPart.value == "home"){
            viewPart.value = "country"
        }else{
            viewPart.value = "home"
        }
    }

    function changeViewPart(name) {
        viewPart.value = name
    }

    function setShopCompanyObj(obj){
        shopCompanyObj.value = obj

        loading.value = true

        const orgPart = viewPart.value
        viewPart.value = null

        setTimeout(() => {
            viewPart.value = orgPart
            loading.value = false
        }, 500)
    }

    function getShopCompanyObj(){
        return shopCompanyObj.value
    }

    function getCompanyInfo(){
        loading.value = true

        const request = companyApi.getCompanyInfo
        const params = request.getParams()

        params.companycode = userinfoRef.value.selectCompanycode

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                shopCompanyObj.value = res.detail

            }
        })

    }

    function goView(name){
        if (name === "company"){
            goCompanyView()
        }else{
            viewPart.value = name
        }
    }

    function clickReturnBtn(){
        if (viewPart.value !== "home"){
            viewPart.value = "home"
        }else{
            proxy.$router.push({name: "home"})
        }
    }

    provide('shopControlFunc', {
        setShopCompanyObj,
        getShopCompanyObj,
        changeViewPart
    })

    onMounted(() => {
        width.value = proxy.$refs.shopControllerViewDom.offsetWidth
        console.log(proxy.showReturnBtn !== false)
        getCompanyInfo()
    })
</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;
    }

    .padding-box {
        padding: 10px;
        box-sizing: border-box;
    }

    .operation-box {
        display: flex;
        justify-content: space-between;
    }

    .title-option-box {
        margin-bottom: 20px;
        text-align: left;
    }
</style>